// extracted by mini-css-extract-plugin
export var container = "_cs-0";
export var popoverContent = "_cs-1";
export var tosLink = "_cs-2";